import $ from 'jquery';

var search_button_desktop = $('.header__search-wrapper-submit-desktop');
var search_button_mobile = $('.header__search-wrapper-submit-mobile');

var search_field_desktop = $('.search-input');
var search_field_mobile = $('.search-input-mobile');

var form_desktop = $('#desktop_search');
var form_mobile = $('#mobile_search');

search_button_desktop.on("click", function () {
	if (search_field_desktop.val()) {
		form_desktop.submit();
	}
});

search_button_mobile.on("click", function () {
	if (search_field_mobile.val()) {
		form_mobile.submit();
	}
});